export const CLIENT_PER_PAGE: number = 18;
